import classNames from 'classnames';
import styles from './tooltip-arrow.module.scss';

export interface TooltipArrowProps {
  /** Additional class name */
  className?: string;
}

const TooltipArrow = ({ className }: TooltipArrowProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      <svg
        className={styles.icon}
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.14 5L20.39 7.19L12.39 17.19L12 17.68L11.61 17.19L3.60999 7.19L1.85999 5"
          fill="#fff"
        />

        <path
          d="M23 6.37012H21.04L20.39 7.19012L12.39 17.1901L12 17.6801L11.61 17.1901L3.61 7.19012L2.96 6.37012H1"
          stroke="#D5DBDE"
        />
      </svg>
    </div>
  );
};

TooltipArrow.displayName = 'TooltipArrow';

export default TooltipArrow;
